import { Controller } from "@hotwired/stimulus"

// Reports one click to POST /user_activities/activity without slowing the click
// down. It uses a beacon (or fetch with keepalive) and never calls
// preventDefault, so a link still navigates at once.
//
// Values:
//   event   - the activity name. Must be in UserActivity::NAMES (the server
//             answers 422 for any other name). Nothing is sent when it is empty.
//   payload - extra fields as a JSON object. The server keeps only the values it
//             allows, so a crafted request cannot store free text.
//
//   <a data-controller="track-activity"
//      data-track-activity-event-value="my_path.activation_prompt_click"
//      data-track-activity-payload-value='{"pillar":"try"}'
//      data-action="click->track-activity#send">
const ENDPOINT = "/user_activities/activity"

export default class extends Controller {
  static values = { event: String, payload: Object }

  send() {
    if (!this.eventValue) return

    const body = JSON.stringify({ ...this.payloadValue, event: this.eventValue })

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const queued = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }))
      if (queued) return
    }

    this.#fetch(body)
  }

  #fetch(body) {
    try {
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body,
        keepalive: true
      }).catch(() => {})
    } catch (error) {
      // Reporting is best effort. A failure must never get in the user's way.
    }
  }
}
